/* eslint-disable no-underscore-dangle */
import videojs from 'video.js';

import { QualityControlItem } from '../qualityControlItem';

import { VIDEO_QUALITIES } from 'src/helpers/constants';

export type VideoQuality = {
  name: string;
  url: string;
};

const MenuButton = videojs.getComponent('MenuButton');
export class QualityControl extends MenuButton {
  private qualities: { name: string; url: string }[];

  private controlItems: QualityControlItem[] = [];

  private initQuality: string = VIDEO_QUALITIES.AUTO;

  constructor(player: any, options: any) {
    super(player, options);
    this.qualities = options.qualities;
    this.setButtonText(VIDEO_QUALITIES.AUTO);
  }

  buildWrapperCSSClass(): string {
    return `vjs-quality-control ${super.buildWrapperCSSClass()}`;
  }

  createItems() {
    const player = this.player_;
    const availableQualities = this.qualities || [];
    const allowedQualities = ['Auto', '1080', '720', '480'];
    const items: QualityControlItem[] = [];
    const onItemClick = (item: QualityControlItem, label: string) => {
      this.setButtonText(label);
      this.controlItems.forEach((im) => {
        im.selected(false);
      });
      item.selected(true);
    };

    allowedQualities.forEach((qualityName) => {
      const quality = availableQualities.find((q) => q.name === qualityName);
      if (quality) {
        items.push(
          new QualityControlItem(
            player,
            { label: quality.name, url: quality.url, selectable: true, selected: this.isMapQualityIndex(quality.name) },
            onItemClick,
          ),
        );
      }
    });

    this.controlItems = items;

    return items;
  }

  isMapQualityIndex(currentLabel: string) {
    return currentLabel === this.initQuality;
  }

  setButtonText(text: string) {
    this.menuButton_.el().innerHTML = text;
  }

  setQualities(qualities: VideoQuality[]) {
    this.qualities = qualities;
  }

  getCurrentQulity() {
    return this.initQuality;
  }

  onSetQuility(qualityKey: string) {
    this.initQuality = qualityKey;

    const availableQualities = this.qualities || [];
    const quality = availableQualities.find((q) => q.name === qualityKey);

    const player = this.player_;
    if (quality) {
      player.src({
        src: quality.url,
      });
      this.setButtonText(quality.name);
    }
  }
}

export default QualityControl;
